import React, { useEffect, useMemo, useState } from 'react';
import { Box } from '@mui/material';
import useWindowDimensions from 'common/hooks/useWindowDimensions';
import { useSelector } from 'react-redux';
import { store } from 'store/store';
import * as UserTypes from 'features/user/userTypes';
import { AppConfig } from 'AppConfig';
import NoAvailableReports from 'features/frontoffice/component/noAvailableReports';

import Carousel from 'common/bstCarousel';

import * as Actions from './actions/actions';
import _ from 'lodash';

const ExclusiveReports = ({ isTablet = false, searchTerm = '', viewMode = 'grid' }) => {
  const { width } = useWindowDimensions();
  const exclusiveData = useSelector((state) => state.fo.exclusive);
  const currentTenantCd = useSelector((state) => state.user.currentTenantCd);

  const [data, setData] = useState(exclusiveData);

  const filterList = (value) => {
    if (Array.isArray(exclusiveData)) {
      const filteredData = _.filter(exclusiveData, function (report) {
        return report.displayText
          ? report.displayText.toLowerCase().includes(value?.toLowerCase())
          : false;
      });
      setData(filteredData);
    }
  };

  useEffect(() => {
    setData(exclusiveData);
  }, [exclusiveData]);

  useEffect(() => {
    store.dispatch({
      type: UserTypes.APP_SWITCHED,
      payload: AppConfig.HEADER_MENU_TYPE.FO
    });
    store.dispatch(Actions.fetchExclusiveReports());
  }, [currentTenantCd]);

  const filteredData = useMemo(() => {
    const list = Array.isArray(data) ? data : [];
    const term = (searchTerm || '').trim().toLowerCase();
    if (!term) return list;
    return list.filter((item) => (item?.displayText || '').toLowerCase().includes(term));
  }, [data, searchTerm]);

  return (
    <>
      {Array.isArray(filteredData) && filteredData.length > 0 && (
        <>
          <Box className="has-carousel frequently-run-carousel">
            <Carousel
              type={AppConfig.EXCLUSIVE_CAROUSEL}
              items={filteredData}
              viewWidth={width}
              cardWidth={AppConfig.HOME_CUSTOM_CARD_WIDTH}
              cardHeight={AppConfig.HOME_CUSTOM_CARD_HEIGHT}
              isTablet={isTablet}
              viewMode={viewMode}
            />
          </Box>
        </>
      )}
      {!filteredData.length && (
        <NoAvailableReports />
      )}
    </>
  );
};

export default ExclusiveReports;
